import React from "react";
import { Grid, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { history } from "../../../../../helpers";
import { routePaths } from "../../../../config/route-paths";
import {useTranslation} from 'react-i18next';
import { Skeleton } from '@material-ui/lab'
const useStyle = makeStyles((theme) => ({
  viewButton: {
    borderRadius: "20px",
    color: theme.palette.eWhite?.base,
    padding: "4% 1.4rem !important",
    "&:hover": {
      backgroundColor: theme.palette.eTertiary?.hover,
    },
    background:theme.palette.eTertiary.base,
    textTransform:"capitalize"
  },
  payButton: {
    borderRadius: "20px",
    color: theme.palette.eWhite?.base,
    backgroundColor: theme.palette.eSecondary?.base,
    padding: "4% 1.4rem !important",
    "&:hover": {
      backgroundColor: theme.palette.eSecondary?.hover,
    },
    textTransform:"capitalize"
  },
  viewBillButton:{
    marginTop:"0.1rem"
  }
}));
export default function E_BillsButton() {
  let classes = useStyle();
  const {t:labels, ready: labelReady} = useTranslation("label-E_POSTPAID_ACCOUNTSUMMARY");

  const viewClick = () => {
    history.push(routePaths.BILL_DETAILS);
  };
  const payBillClick = () => {
    history.push(routePaths.INITIATE_PAYMENT);
  };
  return (
    <Grid container justify="center" spacing={2} className={classes.viewBillButton}>
      <Grid item>
        <Button
          variant="outlined"
          className={classes.viewButton}
          onClick={viewClick}
        >
          {labelReady ? labels("E_VIEW_BILL") : <Skeleton />}
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="outlined"
          className={classes.payButton}
          onClick={payBillClick}
        >
          {labelReady ? labels("E_PAY_BILL") : <Skeleton />}
        </Button>
      </Grid>
    </Grid>
  );
}
